import React, { useState } from 'react';
import { Modal, Form, Input, InputNumber, DatePicker, Alert, Row, Col } from 'antd';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { enregistrerPaiement } from '../../../services/commandeAttestationDigitaleService';
import { useTranslation } from 'react-i18next';
import { localeIntl } from '../../../i18n/format';

export default function EnregistrerChequeModal({ open, commande, onClose, onSuccess }) {
  const { t } = useTranslation('attestationsDigitales');
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      await enregistrerPaiement(commande.commandeTrackingId, {
        numeroCheque:      values.numeroCheque,
        montantCheque:     values.montantCheque,
        banqueEmettrice:   values.banqueEmettrice,
        dateEmissionCheque:  values.dateEmissionCheque?.format('YYYY-MM-DD'),
        dateReceptionCheque: values.dateReceptionCheque?.format('YYYY-MM-DD') || null,
        notesPaiement:     values.notesPaiement || null,
      });
      toast.success(t('cheque.succes', { numero: commande.numeroCommande }));
      form.resetFields();
      onSuccess?.();
      onClose();
    } catch (err) {
      if (err?.errorFields) return;
      toast.error(err?.response?.data?.message || t('cheque.erreur'));
    } finally {
      setLoading(false);
    }
  };

  const montantTtc = commande?.montantTotal;

  return (
    <Modal
      title={<span style={{ fontWeight: 700 }}>{t('cheque.titre', { numero: commande?.numeroCommande })}</span>}
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      okText={t('cheque.enregistrer')}
      cancelText={t('actions.annuler')}
      confirmLoading={loading}
      okButtonProps={{ style: { background: '#1677ff' } }}
      width={560}
      destroyOnClose
    >
      <Alert
        type="info"
        showIcon
        message={
          <span>
            <b>{commande?.compagnieRaisonSociale}</b> - {t('cheque.attestations', { quantite: commande?.quantite?.toLocaleString() })}
            {montantTtc && <> {t('cheque.montantAttendu')} <b>{Number(montantTtc).toLocaleString(localeIntl())} FCFA</b></>}
          </span>
        }
        style={{ marginBottom: 20, borderRadius: 8 }}
      />

      <Form form={form} layout="vertical" initialValues={{ dateReceptionCheque: dayjs() }}>
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item label={t('cheque.numero')} name="numeroCheque"
              rules={[{ required: true, message: t('cheque.obligatoire') }]}>
              <Input placeholder={t('cheque.numeroExemple')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={t('cheque.montant')} name="montantCheque"
              rules={[{ required: true, message: t('cheque.obligatoire') }, { type: 'number', min: 1 }]}>
              <InputNumber
                style={{ width: '100%' }}
                placeholder={montantTtc ? String(montantTtc) : t('cheque.montantPlaceholder')}
                formatter={(v) => v ? Number(v).toLocaleString('fr-FR') : ''}
                parser={(v) => v?.replace(/\s/g, '').replace(',', '.') || ''}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label={t('cheque.banque')} name="banqueEmettrice"
          rules={[{ required: true, message: t('cheque.obligatoire') }]}>
          <Input placeholder={t('cheque.banqueExemple')} />
        </Form.Item>

        <Row gutter={12}>
          <Col span={12}>
            <Form.Item label={t('cheque.dateEmission')} name="dateEmissionCheque"
              rules={[{ required: true, message: t('cheque.obligatoire') }]}>
              <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" placeholder={t('cheque.formatDate')} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={t('cheque.dateReception')} name="dateReceptionCheque">
              <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" placeholder={t('cheque.dateReceptionPlaceholder')} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label={t('cheque.notes')} name="notesPaiement">
          <Input.TextArea rows={2} placeholder={t('cheque.notesPlaceholder')} maxLength={300} showCount />
        </Form.Item>
      </Form>
    </Modal>
  );
}
